import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Sparkles, HeartHandshake } from "lucide-react";

const MOODS = [
  { key: "great", label: "Really good", tint: "bg-[#CDE7E3] text-slate-700" },
  { key: "ok", label: "I'm ok", tint: "bg-[#E3F0EE] text-slate-700" },
  { key: "not_good", label: "Not great", tint: "bg-[#DCEFEC] text-slate-700" },
  { key: "struggling", label: "Struggling", tint: "bg-[#2E9D96] text-white" },
];

export default function WellnessCheckCard({ onDone }) {
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const pick = async (mood) => {
    setSubmitting(true);
    try {
      const { data } = await api.post("/checkin", { mood, note });
      if (data.support?.show) {
        toast("Thanks for being honest with me. Let's get you some support.", { duration: 5000 });
      } else {
        toast.success("Noted. I'm glad you're checking in.");
      }
      onDone?.(data);
    } catch (err) {
      toast.error("Couldn't save check-in");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="wellness-card"
      className="relative overflow-hidden rounded-3xl border border-slate-100 shadow-sm bg-white"
      style={{
        backgroundImage: "linear-gradient(to right, rgba(255,255,255,0.92), rgba(255,255,255,0.85)), url(https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxjYWxtJTIwbWluaW1hbCUyMG5hdHVyZXxlbnwwfHx8fDE3ODkwMDUyMDN8MA&ixlib=rb-4.1.0&q=85)",
        backgroundSize: "cover",
      }}
    >
      <div className="p-6 md:p-7">
        <div className="flex items-center gap-2">
          <HeartHandshake className="text-[#2E9D96]" size={18} />
          <span className="text-xs uppercase tracking-[0.22em] text-[#2E9D96] font-semibold">Daily check-in</span>
        </div>
        <h3 className="font-display text-2xl md:text-3xl text-slate-800 mt-2">Hey — how are you, honestly?</h3>
        <p className="text-slate-600 mt-1 text-sm">No wrong answer. This helps me be there for you.</p>

        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Anything on your mind? (optional)"
          className="mt-4 w-full rounded-xl border border-slate-200 bg-white px-4 py-3 zaf-focus text-sm"
          data-testid="wellness-note"
        />

        <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-2">
          {MOODS.map((m) => (
            <button
              key={m.key}
              disabled={submitting}
              onClick={() => pick(m.key)}
              className={`rounded-full py-2.5 px-4 text-sm font-semibold transition-all hover:-translate-y-0.5 disabled:opacity-50 ${m.tint}`}
              data-testid={`wellness-mood-${m.key}`}
            >
              {m.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
